import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormHelperText, Typography } from '@mui/material';
const HelperText = ({ name, error, description }) => (_jsxs(_Fragment, { children: [error && (_jsx(FormHelperText, { error: true, component: "div", id: `helper-text-${name}`, sx: { marginTop: 4 }, children: _jsx(Typography, { variant: "body2", component: "span", children: error }) })), description && (_jsx(FormHelperText, { component: "div", id: `description-text-${name}`, children: _jsx(Typography, { variant: "body2", component: "div", children: description }) }))] }));
HelperText.defaultProps = {
    error: undefined,
    description: undefined,
};
export default HelperText;
//# sourceMappingURL=HelperText.js.map